import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import { FeatureFlags, PlatformKey } from '../models/feature-flags.model';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly flagsSubject = new BehaviorSubject<FeatureFlags | null>(null);
  readonly flags$ = this.flagsSubject.asObservable();

  /** Called by APP_INITIALIZER — loads flags from static environment config. */
  load(): Observable<null> {
    this.flagsSubject.next(environment.featureFlags);
    return of(null);
  }

  isPlatformEnabled(platform: PlatformKey): boolean {
    return this.flagsSubject.value?.platforms[platform]?.enabled ?? false;
  }

  isFeatureEnabled(feature: string): boolean {
    return this.flagsSubject.value?.features[feature] ?? false;
  }

  getEnabledPlatforms(): PlatformKey[] {
    const platforms = this.flagsSubject.value?.platforms ?? {};
    return Object.entries(platforms)
      .filter(([_, p]) => p.enabled)
      .map(([key]) => key as PlatformKey);
  }

  getDefaultCategories(): string[] {
    return this.flagsSubject.value?.defaultCategories ?? [];
  }
}
